/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import { Component } from "react";
import { IRepairTrackerProps, IRepairTrackerState } from "./RepairTrackerProps";
import moment from "moment";
import { IoCloseOutline } from "react-icons/all";
import { Overlay } from "../Overlay/Overlay";
import PhotosModal from "../shared/gallery-modal/GalleryModal";
import { Link } from "react-router-dom";
import { StepsProps, subTask } from "./TrackerStepper/TrackerStepperProps";

import { Box, Heading, Button, SimpleGrid } from "@chakra-ui/react";
import { InspectionService } from "../Services/inspectionService";
import { TrackerStepper } from "./TrackerStepper/TrackerStepper";
import { ImagesListEntity } from "../modals/JobEstimationDetail";
import { Mixpanel } from "./../Services/MixPanel";
import { CurrentStatus } from "./CurrentStatus/CurrentStatus";
import { IUser } from "../CommonProps";

require("./RepairTracker.css");

export class RepairTracker extends Component<
  IRepairTrackerProps,
  IRepairTrackerState
> {
  inspectionsService = new InspectionService();
  inspection: any;

  params: any;
  inspectionLink = "/inspection";

  days: number = 0;

  dummyComments = [
    {
      avatar: "https://randomuser.me/api/portraits/men/1.jpg",
      title: "John Doe",
      description: "Parts Delayed: We've received an update from our supplier, the tailgate has been delayed by one day. Rest assured, as soon as the part arrives, we will begin the repair immediately",
      createdAt: "2024-06-01T10:30:00Z"
    },
    {
      avatar: "https://randomuser.me/api/portraits/men/2.jpg",
      title: "Jane Smith",
      description: "Parts Delayed: We've received an update from our supplier, the tailgate has been delayed by one day. Rest assured, as soon as the part arrives, we will begin the repair immediately",
      createdAt: "2024-06-02T14:15:00Z"
    },
    {
      avatar: "https://randomuser.me/api/portraits/men/3.jpg",
      title: "Mike Johnson",
      description: "Parts Delayed: We've received an update from our supplier, the tailgate has been delayed by one day. Rest assured, as soon as the part arrives, we will begin the repair immediately",
      createdAt: "2024-06-03T09:45:00Z"
    }
    
    
  ];

  // Add planning state
  state = {
    expectedArrival: "",
    expectedPickup: "",
    showRepairPhotos: false,
    inspectionForm: null,
    stepItems: [],
  };

  constructor(props: IRepairTrackerProps) {
    super(props);
    let expectedArrival = this.getDate("arrival"),
      selectedPickupDate = this.getDate("pickup");
    this.state = {
      ...this.state,
      expectedArrival: expectedArrival
        ? expectedArrival.format("DD MMM YYYY ddd / hh:mm a")
        : "",
      expectedPickup: selectedPickupDate
        ? selectedPickupDate.format("DD MMM YYYY ddd / hh:mm a")
        : "",
    };

    if (expectedArrival && selectedPickupDate) {
      const days = selectedPickupDate
        .startOf("day")
        .diff(expectedArrival.startOf("day"), "days");
      this.days = days;
    }
    const urlSearchParams = new URLSearchParams(
      window.location.search.toLowerCase()
    );
    this.params = Object.fromEntries(urlSearchParams.entries());
    if (this.params["estimateid"]) {
      this.inspectionLink =
        this.inspectionLink + "?estimateid=" + this.params["estimateid"];
    }

    this.checkInspection();
  }

  componentDidMount() {
    Mixpanel.track("RepairTracker Page Viewed", {
      timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
      estimateId: this.props.estimateDetails.estimateId,
      estimateNumber: this.props.estimateDetails.estimateNumber,
    });
    this.loadStepsState();
  }

  componentDidUpdate(prevProps: IRepairTrackerProps) {
    if (prevProps.stepItems !== this.props.stepItems) {
      this.loadStepsState();
    }
  }

  loadStepsState() {
    let newSteps: StepsProps[];

    this.createSteps().then((res: StepsProps[]) => {
      newSteps = res;
      this.setState({ stepItems: newSteps });
    });
  }

  async createSteps(): Promise<StepsProps[]> {
    const steps: StepsProps[] = [];
    Object.keys(this.props.stepItems).forEach((each: any) => {
      const status = this.props.stepItems[each]?.stepStatus;
      let label = each;
      let content;
      if (
        this.props.stepItems[each]?.stepStatus === "Completed" ||
        this.props.stepItems[each]?.stepStatus === "Complete"
      ) {
        label = this.props.stepItems[each]?.labelAfter;
        content = this.props.stepItems[each]?.detailAfter;
      } else {
        label = this.props.stepItems[each]?.labelBefore;
        content = this.props.stepItems[each]?.detail;
      }

      const step: StepsProps = {
        label: label,
        content: content,
        date:
          each === "collect"
            ? this.getDate("pickup", true)
            : each === "arrival"
            ? this.getDate("arrival", true)
            : this.getDate(each)?.format("DD MM YYYY"),
        stepStatus: status,
        onHoldReason: this.props.stepItems[each]?.onHoldReason,
        onHoldUntil: this.props.stepItems[each]?.onHoldUntil,
        isAccordion: this.props.stepItems[each]?.isAccordion,
        icon: this.props.stepItems[each]?.icon,
      };

      if (this.props.stepItems[each].subTasks) {
        const subTasks: any = this.props.stepItems[each].subTasks;
        const subTaskItem: subTask[] = [];
        if (subTasks) {
          Object.keys(subTasks).forEach((task: any) => {
            const subTaskStep: subTask = {
              label: subTasks[task]?.status,
              detail: subTasks[task]?.detail,
              subStepStatus: subTasks[task]?.stepStatus,
            };
            return subTaskItem.push(subTaskStep);
          });
          step.subTasks = subTaskItem;
        }
      }
      steps.push(step);
    });
    return steps;
  }

  
  getDate(type: string): moment.Moment;
  getDate(type: string, formatted: boolean): string;
  getDate(type: string, formatted?: boolean) {
    var dt = null;
    switch (type) {
      case "arrival":
        if (this.props.estimateDetails.isVehicleOnSite) {
          dt = this.props.estimateDetails?.actualArrival
            ? formatted
              ? "Arrived: " +
                moment(this.props.estimateDetails?.actualArrival)?.format(
                  "DD/MM/YYYY"
                )
              : moment(this.props.estimateDetails?.actualArrival)
            : null;
        } else {
          dt = this.props.estimateDetails?.expectedArrival
            ? formatted
              ? "Date of Arrival: " +
                moment(this.props.estimateDetails?.expectedArrival)?.format(
                  "DD/MM/YYYY HH:mm A"
                )
              : moment(this.props.estimateDetails?.expectedArrival)
            : null;
        }
        break;
      case "pickup":
        if (this.props.estimateDetails.isVehicleCollected) {
          dt = this.props.estimateDetails?.actualPickup
            ? formatted
              ? "Collected: " +
                moment(this.props.estimateDetails?.actualPickup)?.format(
                  "DD/MM/YYYY"
                )
              : moment(this.props.estimateDetails?.actualPickup)
            : null;
        } else {
          dt = this.props.estimateDetails?.expectedPickup
            ? formatted
              ? "Est. Collection: " +
                moment(this.props.estimateDetails?.expectedPickup)?.format(
                  "dddd, D MMMM YYYY"
                )
              : moment(this.props.estimateDetails?.expectedPickup)
            : null;
        }
        break;
    }
    return dt;
  }

  async checkInspection() {
    if (this.props.estimateDetails.trackables) {
      this.props.estimateDetails.trackables
        .filter((x: any) => ["1PC"])
        .forEach(async (ele: any) => {
          if (ele.id == "1PC" && ele.status == "Completed") {
            let preChecks: any;
            preChecks = await this.inspectionsService.getInspectionById(
              this.props?.estimateDetails?.estimateId
            );
            if (preChecks.length > 0) {
              return this.setState({ inspectionForm: preChecks });
            }
          }
        });
    }
  }

  getLatestReason() {
      const filtered = this.props.estimateDetails.notes.filter(n =>
        n.noteType == 'COLLECTION_DATE_CHANGE'
      );
      if (!filtered.length) return null;
      const latest = filtered.sort(
        (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
      )[0];
      const reason =
        typeof latest?.body === "string"
          ? latest.body
              .replace("Request date Change due to", "")
              .split("\n")[0]
              .trim()
          : "";
      return reason
    }

  public render() {
    
    let images: any[] = [];
    this.props?.estimateDetails?.ImagesList?.forEach(
      (list: ImagesListEntity) => {
        return list?.images?.forEach((image: any) => {
          let filteredTrackable = false;
          if (
            this.props.estimateDetails.trackables &&
            this.props.estimateDetails.trackables.length > 0
          ) {
            this.props.estimateDetails.trackables
              .filter((x: any) => ["9RP"])
              .forEach((ele: any) => {
                if (ele.id == "9RP" && ele.status == "Completed") {
                  filteredTrackable = true;
                }
              });
          }
          try {
            if (image.category === "Handover" && filteredTrackable) {
              const url = this.props.ibsAdonisService.getHighResolutionImageUrl(
                image.full.id
              );
              let originalClass = "handover";
              const thumb = this.props.ibsAdonisService.getHighResolutionImageUrl(
                image.thumbnail.id
              );
              return images.push({
                original: url,
                thumbnail: thumb,
                originalClass: originalClass,
              });
            }
          } catch (error) {
            console.error("🚀 ~ Error in processing handover image:")
          }
        });
      }
    );

    // --- Refactor: move complex JSX to variables ---
    const inspectionButton: React.ReactNode = this.state.inspectionForm !== null ? (
      <Link to={String(this.inspectionLink)}>
        <Button w={"100%"} colorScheme="blue">
          Pre-repair Inspection Report
        </Button>
      </Link>
    ) : null;

    const photosModal = this.props.estimateDetails && images.length > 0 ? (
      <PhotosModal props={this.props} imagesList={images}></PhotosModal>
    ) : null;
    // --- End refactor ---

    return (
      <Box>
        {this.state.showRepairPhotos ? (
          <Overlay isMenuOverlay={true}>
            <div className={"vehiclePhotoContainer"}>
              <div className={"closeIcon closeImagesDialog"}>
                <IoCloseOutline
                  onClick={() => this.setState({ showRepairPhotos: false })}
                />
              </div>
              <div className={"clearfix"}></div>
              {this.props.images.map((e) => {
                return (
                  <img
                    className={"vehiclePhoto"}
                    src={this.props.ibsAdonisService.getHighResolutionImageUrl(
                      e.full.id
                    )}
                  />
                );
              })}
            </div>
          </Overlay>
        ) : undefined}
        <Box>
          <SimpleGrid mt={6} columns={1} spacing={3}>
            {inspectionButton}
            {photosModal}
          </SimpleGrid>
          <Box display="flex" flexFlow="column" mx={{ base: 0, md: 20 }}>
            {this.state.stepItems.length > 0 ? (
              <TrackerStepper steps={this.state.stepItems} dateChangeReason={this.getLatestReason()} />
            ) : null}
          </Box>
        </Box>
      </Box>
    );
  }
}
